import React from 'react';
import { announcements } from '../../data/content';
export function AnnouncementBar() {
  const items = [...announcements, ...announcements, ...announcements, ...announcements];
  return <div className="overflow-hidden bg-ink py-3 text-[13px] font-bold uppercase tracking-wider text-cream" role="region" aria-label="Current offer" data-id="element-13" data-mp="1tn7lfk3su7mq">
      <div className="animate-marquee flex w-max items-center" data-id="element-14" data-mp="1opz1pf305vjd">
        {items.map((item, i) => <span key={i} className="flex items-center whitespace-nowrap" data-id="element-15" data-mp="2mbdagj1vyisd" data-mpi={i}>
            <span className={i % 2 === 0 ? 'text-gold-soft' : 'text-cream'} data-id="element-16" data-mp="2he3cug4cf0tg">{item}</span>
            <span className="mx-8 text-[8px] text-gold" aria-hidden data-id="element-17" data-mp="2cd78k1g2xcni">◆</span>
          </span>)}
      </div>
    </div>;
}